import axios from 'axios'
import config from "../core/config/config";
import {Message, Loading} from 'element-ui';
import storage from "../core/utils/storage";

let loadingInstance = null; //这里是loading
let loadingInstanceTimeId = 0; //这里是loading
//使用create方法创建axios实例
// timeout: 7000, // 请求超时时间
export const Service = axios.create({
    baseURL: config.getIMBaseUrl(),
    method: 'post',
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'

    }
});
// 添加请求拦截器
Service.interceptors.request.use(config => {
    if (!loadingInstanceTimeId) {
        loadingInstanceTimeId = setTimeout(() => {
            loadingInstance = Loading.service({
                lock: true,
                text: 'loading...'
            });
        }, 2000);
    }
    config.headers.Authorization = storage.get('token');
    return config
});
// 添加响应拦截器
Service.interceptors.response.use(response => {
    if (loadingInstanceTimeId) {
        if (loadingInstance) {
            loadingInstance.close();
            loadingInstance = null;
        }
        clearTimeout(loadingInstanceTimeId);
        loadingInstanceTimeId = 0;
    }
    return response.data
}, error => {
    // console.log('TCL: error', error);
    const msg = error.Message !== undefined ? error.Message : '';
    Message({
        message: '网络错误' + msg,
        type: 'error',
        duration: 3 * 1000
    });
    loadingInstance.close();
    return Promise.reject(error)
});